import { IMealCredit } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseMealCreditsDetailsPage.utils';
import { isDateValidAndPast } from 'src/components/oneCorp/features/MealCredit/utils/isDateValidAndPast';
import { parseZonedTimeToUtc } from 'src/utilities/parseZonedTimeToUtc';
import { USTimeZone } from 'src/utilities/timeZones';

export function isMealCreditExpired(mealCredit: IMealCredit | null): boolean {
  if (!mealCredit?.expiration) {
    return false;
  }

  // Backend sends PST time but formats it as UTC (with 'Z')
  // We need to remove 'Z' and interpret it as PST local time
  const localTimeString = mealCredit.expiration.replace('Z', '');
  const expirationDate = parseZonedTimeToUtc(
    localTimeString,
    USTimeZone.PACIFIC
  );

  if (expirationDate === null) {
    return false;
  }

  return isDateValidAndPast(expirationDate);
}
